import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { API, api } from "@/lib/api";
import { fileUrl as authFileUrl } from "@/lib/upload";

/** Shared data-fetch for all 3 property-website pages (Home/Details/Sponsors).
 * Preview mode (admin "Preview" button, works pre-publish) and the live public
 * page return the exact same shape from the backend's listing_view(). */
export function useListingData() {
  const { slug } = useParams();
  const preview = new URLSearchParams(useLocation().search).get("preview") === "1";
  const [listing, setListing] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const request = preview ? api.get(`/admin/delivery-projects/${slug}/website-preview`) : api.get(`/public/listing/${slug}`);
    request.then((response) => setListing(response.data)).catch(() => setError(preview ? "Preview is unavailable. Sign in as an admin to continue." : "This property website is not available."));
  }, [preview, slug]);

  useEffect(() => {
    if (!listing) return;
    document.title = listing.full_address || listing.project_name || "Property Website";
  }, [listing]);

  return { slug, preview, listing, error };
}

/** Preview mode may view a property before it's published — the public file
 * endpoint 404s then, so viewing goes through the authenticated admin endpoint. */
export function listingFileUrl(listing, slug, preview, file) {
  if (!file) return "";
  return preview ? authFileUrl(listing.id, file.id, true) : `${API}/public/delivery-galleries/${slug}/files/${file.id}`;
}
